import React from "react";

interface SliderProps {
    value: number;
    onChange: (value: number) => void;
    min: number;
    max: number;
    step?: number;
    label?: string;
    disabled?: boolean;
    className?: string;
}

export function Slider({
    value,
    onChange,
    min,
    max,
    step = 0.1,
    label,
    disabled = false,
    className = "",
}: SliderProps) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(parseFloat(event.target.value));
    };

    const percentage = ((value - min) / (max - min)) * 100;

    return (
        <div className={`space-y-2 ${className}`}>
            {label && (
                <div className="flex justify-between items-center">
                    <label className="text-sm font-medium text-foreground">{label}</label>
                    <span className="text-sm text-muted-foreground">{value}</span>
                </div>
            )}
            <div className="relative">
                <input
                    type="range"
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    onChange={handleChange}
                    disabled={disabled}
                    className="w-full h-2 rounded-lg appearance-none cursor-pointer slider"
                    style={{
                        background: `linear-gradient(to right, hsl(var(--primary)) 0%, hsl(var(--primary)) ${percentage}%, hsl(var(--secondary)) ${percentage}%, hsl(var(--secondary)) 100%)`,
                    }}
                />
                <style
                    dangerouslySetInnerHTML={{
                        __html: `
                        .slider::-webkit-slider-thumb {
                            -webkit-appearance: none;
                            appearance: none;
                            height: 18px;
                            width: 18px;
                            background: hsl(var(--primary));
                            border-radius: 50%;
                            cursor: pointer;
                            border: 2px solid hsl(var(--background));
                            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                        }

                        .slider::-webkit-slider-thumb:hover {
                            box-shadow: 0 0 0 4px hsl(var(--primary) / 0.2);
                        }

                        .slider::-moz-range-thumb {
                            height: 18px;
                            width: 18px;
                            background: hsl(var(--primary));
                            border-radius: 50%;
                            cursor: pointer;
                            border: 2px solid hsl(var(--background));
                            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                        }

                        .slider::-moz-range-thumb:hover {
                            box-shadow: 0 0 0 4px hsl(var(--primary) / 0.2);
                        }

                        .slider:focus {
                            outline: none;
                        }

                        .slider:focus::-webkit-slider-thumb {
                            box-shadow: 0 0 0 4px hsl(var(--primary) / 0.2);
                        }

                        .slider:disabled {
                            opacity: 0.5;
                            cursor: not-allowed;
                        }
                    `,
                    }}
                />
            </div>
        </div>
    );
}
